import React from 'react'
import instagramIcon from '../../../../assets/images/instagram-icon.svg'
import phoneIcon from '../../../../assets/images/phone-icon.svg'
import telegramIcon from '../../../../assets/images/telegram-icon.svg'
import gmailIcon from '../../../../assets/images/you-tube-icon.png'

const Footer = () => {
	return (
		<div className='bg-[#ffffff] dark:bg-[#2E2D2D]'>
			<div className='grid grid-cols-12 gap-2 sm:gap-3 p-4'>
				<div className='md:col-span-3 col-span-6 text-xl-start text-center'>
					<a
						className='footer-contact-label flex items-center gap-2 sm:gap-3'
						href='https://t.me/bozorov_school'
						target={'_blank'}
						rel='noreferrer'
					>
						<img
							src={telegramIcon}
							alt='telegram'
							className='size-[20px] sm:size-[28px]'
						/>
						<span className='text-[#292A32] dark:text-[#FFFFFF] font-semibold text-[14px]'>
							bozorov_school
						</span>
					</a>
				</div>
				<div className='md:col-span-3 col-span-6'>
					<a
						className='footer-contact-label flex items-center gap-2 sm:gap-3'
						href='https://www.instagram.com/bozorov_school/'
						target={'_blank'}
						rel='noreferrer'
					>
						<img
							src={instagramIcon}
							alt='instagram'
							className='size-[20px] sm:size-[28px]'
						/>
						<span className='text-[#292A32] dark:text-[#FFFFFF] font-semibold text-[14px]'>
							bozorov_school
						</span>
					</a>
				</div>
				<div className='md:col-span-3 col-span-6 text-xl-start text-center'>
					<a
						className='footer-contact-label flex items-center gap-2 sm:gap-3'
						href='https://www.youtube.com/@bozorovschool'
						target={'_blank'}
						rel='noreferrer'
					>
						<img
							src={gmailIcon}
							alt='gmail'
							className='size-[20px] sm:size-[28px]'
						/>
						<span className='text-[#292A32] dark:text-[#FFFFFF] font-semibold text-[14px]'>
							@bozorovschool
						</span>
					</a>
				</div>
				<div className='md:col-span-3 col-span-6 text-xl-start text-center'>
					<a
						className='footer-contact-label flex items-center gap-2 sm:gap-3'
						href='tel:+998951464040'
					>
						<img
							src={phoneIcon}
							alt='phone'
							className='size-[20px] sm:size-[28px]'
						/>
						<span className='text-[#292A32] dark:text-[#FFFFFF] font-semibold text-[14px]'>
							+998 95 146 40 40
						</span>
					</a>
				</div>
			</div>
		</div>
	)
}

export default Footer
